import api from "./api";

export async function listCvFilesForUser(userId) {
    const res = await api.get(`/CurriculumVitae/files/${userId}`);
    return res.data;
}

// The file name, not the S3 key: the backend rebuilds the key from the user id so a
// request cannot reach an object outside that user's CV prefix.
export async function deleteCvFile(userId, fileName) {
    const res = await api.delete(
        `/CurriculumVitae/files/${userId}/${encodeURIComponent(fileName)}`
    );
    return res.data;
}

export async function generateCvPdf(
    userId,
    {title, comment, variantId, attachmentIds, includePhoto} = {}
) {
    const res = await api.post(
        `/CurriculumVitae/generate/${userId}`,
        {
            // `variant_id: null` renders the whole profile, exactly as before variants existed.
            title: title ?? null,
            comment: comment ?? null,
            variant_id: variantId ?? null,
            // An empty list means no annexes — unlike a variant's curated lists, where
            // null means "everything from the profile".
            attachment_ids: attachmentIds ?? [],
            include_photo: !!includePhoto,
        },
        {responseType: "blob"}
    );

    const cd = res.headers?.["content-disposition"] || "";
    const filename = extractFilenameFromContentDisposition(cd) || `CV_${userId}.pdf`;

    const cvId = res.headers?.["x-cv-id"] || null;
    const cvUrl = res.headers?.["x-cv-url"] || null;

    return {blob: res.data, filename, cvId, cvUrl};
}

function extractFilenameFromContentDisposition(contentDisposition) {
    const match = /filename\*?=(?:UTF-8''|")?([^\";]+)/i.exec(contentDisposition || "");
    if (!match?.[1]) return null;

    try {
        return decodeURIComponent(match[1].replace(/"/g, "").trim());
    } catch {
        return match[1].replace(/"/g, "").trim();
    }
}